// "Subscribe in Calendar" control — fetches the user's read-only ICS feed URL
// and offers copy / open. Self-hides if the endpoint isn't available yet (so
// web can ship ahead of the backend deploy).
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { getCalendarFeedUrl } from "@/api/calendar";
import { Button } from "@/components/ui";

export function SubscribeButton() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);

  const feed = useQuery({
    queryKey: ["calendar", "feed-url"],
    queryFn: () => getCalendarFeedUrl(),
    retry: false,
  });

  // Endpoint not deployed / errored → render nothing.
  if (feed.isError || (!feed.isLoading && !feed.data)) return null;

  return (
    <div className="relative">
      <Button size="sm" variant="secondary" loading={feed.isLoading} onClick={() => setOpen((v) => !v)}>
        {t("Subscribe in Calendar")}
      </Button>
      {open && feed.data && (
        <div className="absolute right-0 z-20 mt-2 w-72 rounded-xl border border-black/10 bg-white p-3 shadow-soft">
          <p className="text-xs text-ink-faint">
            {t("Add this URL in your calendar app to subscribe to your homework, tasks and schedule.")}
          </p>
          <code className="mt-2 block truncate rounded-lg bg-black/5 px-2 py-1 text-[11px] text-ink">
            {feed.data.webcal_url}
          </code>
          <div className="mt-2 flex gap-2">
            <Button
              size="sm"
              variant="secondary"
              className="flex-1"
              onClick={() => {
                navigator.clipboard?.writeText(feed.data!.https_url);
                setCopied(true);
                window.setTimeout(() => setCopied(false), 1500);
              }}
            >
              {copied ? t("Copied ✓") : t("Copy link")}
            </Button>
            <a
              href={feed.data.webcal_url}
              className="inline-flex flex-1 items-center justify-center rounded-lg bg-brand-600 px-3 py-1.5 text-xs font-semibold text-white"
            >
              {t("Open in Calendar")}
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
